var BrowserHelper = /** @class */ (function () {
    function BrowserHelper() {
    }
    BrowserHelper.isInternetExplorer = function () {
        var userAgent = window.navigator.userAgent;
        var msie = userAgent.indexOf("MSIE ");
        return msie > 0 || !!userAgent.match(/Trident.*rv\:11\./);
    };
    BrowserHelper.isAppleDevice = function () {
        var userAgent = window.navigator.userAgent;
        return !!userAgent.match(/iPhone|iPad|iPod/i);
    };
    return BrowserHelper;
}());
export { BrowserHelper };
export default BrowserHelper;
